export default __webpack_public_path__ + "static/media/Porque-Portugal-PT.9daab492.jpg";